import React from 'react';
import { Box } from '@mui/material';
import Layout from '../components/Layout';
import logo from '../assets/eliotnest-logo-v3.svg';

const HomePage: React.FC = () => {
  return (
    <Layout>
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          height: '100vh',
          backgroundColor: '#ffffff',
          padding: 3,
        }}
      >
        <Box
          component="img"
          src={logo}
          alt="EliotNest Logo"
          sx={{
            maxWidth: '400px',
            width: '100%',
            height: 'auto',
            objectFit: 'contain',
          }}
        />
      </Box>
    </Layout>
  );
};

export default HomePage;